import React, { useMemo, useState } from "react";
import { isEmpty } from "lodash";
import { Modal } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";

import { Button, HookFormPhoneInput } from "components";
import { COUNTDOWN_TIME, UserProfileFields } from "globalConstants";
import { useInitializeMobilePhoneChangeMutation } from "queries";

import CodeForm from "./codeForm";

import styles from "../modal.module.scss";

const { MobilePhone } = UserProfileFields;

type EditMobilePhoneNumberModalProps = {
	show: boolean;
	onHide: () => void;
	mobilePhoneValue: string;
	setMobilePhoneValue: Function;
};

const EditMobilePhoneNumberModal = ({
	show,
	onHide,
	mobilePhoneValue,
	setMobilePhoneValue,
}: EditMobilePhoneNumberModalProps) => {
	const formMethods = useForm({
		mode: "onChange",
		reValidateMode: "onChange",
		defaultValues: {
			mobilePhone: "",
		},
	});
	const {
		handleSubmit,

		formState: { isValid },
	} = formMethods;

	const [newMobilePhone, setNewMobilePhone] = useState<string>("");

	const {
		mutate: initializeMobilePhoneChange,
		isLoading: isLoadingMobilePhoneChange,
	} = useInitializeMobilePhoneChangeMutation({
		onSuccess: mobilePhone => {
			timer();
			setNewMobilePhone(mobilePhone);
		},
	});

	const [seconds, setSeconds] = useState(COUNTDOWN_TIME);
	const [isActiveTimer, setActiveTimer] = useState(false);

	function timer() {
		setActiveTimer(true);
		let timeLeft = COUNTDOWN_TIME;
		const timerId = setInterval(countdown, 1000);

		function countdown() {
			if (timeLeft === -1) {
				clearTimeout(timerId);
				setActiveTimer(false);
			} else {
				setSeconds(timeLeft);
				timeLeft--;
			}
		}
	}

	const handleSubmitForm = ({ mobilePhone }: { mobilePhone: string }) => {
		initializeMobilePhoneChange({ mobilePhone });
	};

	const textForCodeBtn = useMemo(
		() => (isEmpty(newMobilePhone) ? "send code" : "resend"),
		[newMobilePhone],
	);

	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header closeButton>
				<Modal.Title as="h6" className="text-center">
					Change{" "}
					<span className={styles.changesEntityTitle}>
						{mobilePhoneValue}
					</span>{" "}
					Number
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className={styles.verificationModalBody}>
					<FormProvider {...formMethods}>
						<form onSubmit={handleSubmit(handleSubmitForm)}>
							<div className={styles.phoneVerificationInputWrap}>
								<HookFormPhoneInput
									name={MobilePhone.name}
									colInput={12}
									isLoading={isLoadingMobilePhoneChange}
									isRequired
								/>
							</div>
							<div className={styles.phoneVerificationButtonWrap}>
								<Button
									type="submit"
									value={textForCodeBtn}
									variant="pure-link"
									disabled={
										!isValid ||
										isActiveTimer ||
										isLoadingMobilePhoneChange
									}
								/>

								{isActiveTimer && (
									<div className={styles.timerHolder}>
										<small className={styles.timerText}>
											in{" "}
											<span
												className={styles.timerSeconds}
											>
												{seconds} sec
											</span>
										</small>
									</div>
								)}
							</div>
						</form>
					</FormProvider>

					<CodeForm
						isDisabled={!isValid}
						onHide={onHide}
						setMobilePhoneValue={setMobilePhoneValue}
						newMobilePhone={newMobilePhone}
					/>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default EditMobilePhoneNumberModal;
